let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("asn5g")).then(() => parcelRequire('834To'));